import { TenantTemplateRouterCore } from "@components/tenant/TenantTemplateRouter";
import DefaultPrint from "./default";

const templates = import.meta.glob<{ default: React.ComponentType<any> }>(
  "/src/pages/user/ProviderOrder/Print/templates/*/index.tsx"
);

type ProviderOrderPrintProps = {
};

export default function ProviderOrderPrint(props: ProviderOrderPrintProps) {
  return (
    <TenantTemplateRouterCore<ProviderOrderPrintProps>
      templates={templates}
      DefaultComponent={DefaultPrint}
      passProps={props}
    />
  );
}